<template>
  <div
      id="app"
      :class="{
      'summer-card': this.$store.state.season === 'sommer',
      'winter-card': this.$store.state.season === 'winter',
    }"
  >
    <div
        class="off-canvas position-right"
        id="offCanvas"
        ref="offCanvas"
        data-off-canvas
        data-transition="overlap"
    >
      <!-- Close button -->
      <button
          class="close-button btn-close-off-canvas"
          aria-label="Close menu"
          type="button"
          data-close
      >
        <img src="@/assets/svgs/2024/icons/close-white.svg" alt="close">
      </button>

      <div class="off-canvas-inner-container">
        <mobile-navigation/>
      </div>
    </div>
    <div class="off-canvas-content" data-off-canvas-content>
      <top-navigation v-on:openOffCanvas="openOffCanvas"
                      :hide-nav="this.$route.name === 'map'">
        <div class="top-nav-center">
          <service-switch v-if="showServiceSwitches"/>
          <my-card-infos v-show="showCardInfos"/>
        </div>
      </top-navigation>
      <router-view/>
      <bottom-navigation
          v-on:openOffCanvas="openOffCanvas"
          :hide-nav="this.$route.name === 'map'"
      />
    </div>

    <notifications class="a2hs-notification-group" group="a2hs">
      <template slot="body" slot-scope="props">
        <div class="notification-a2hs">
          <div class="notification-content">
            <a class="title">
              {{ props.item.title }}
            </a>
            <div class="content">{{ props.item.text }}</div>
          </div>
          <div class="button-wrapper">
            <button
                type="button"
                class="btn-a2hs button success"
                @click="promptA2HS(props.item.data.prompt, props.close)"
            >
              <font-awesome-icon :icon="['fal', 'check']"/>
            </button>
            <button
                type="button"
                class="btn-close button alert"
                @click="props.close"
            >
              <font-awesome-icon :icon="['fal', 'times']"/>
            </button>
          </div>
        </div>
      </template>
    </notifications>

    <notifications group="shell" position="bottom center">
      <template slot="body">
        <div class="notification-shell">
          <div
              class="notification-content"
              v-html="$t('pwa.updateAvailable')"
          />
          <div class="button-wrapper">
            <button type="button" class="btn-update" @click="performeUpdate">
              <font-awesome-icon :icon="['fal', 'download']"/>
              {{ $t("pwa.update") }}
            </button>
          </div>
        </div>
      </template>
    </notifications>

    <notifications
        class="notification-registration-group"
        group="registration"
        position="bottom center"
    >
      <template slot="body" slot-scope="props">
        <div class="notification-registration">
          <div class="notification-content" v-html="props.item.text"/>
        </div>
      </template>
    </notifications>

    <div
        :class="{
        'ios-installation-hint': true,
        'show-hint': showIosInstallationHint,
      }"
        ref="iosInstallationHint"
    >
      <div class="install-text">{{ $t("pwa.howToInstallIos") }}</div>
      <div class="btn-close-hint-container">
        <button
            type="button"
            class="button btn-close-hint"
            @click="hideIosInstallationHint"
        >
          <font-awesome-icon :icon="['fal', 'chevron-down']"/>
        </button>
      </div>
      <font-awesome-icon
          class="install-icon"
          :icon="['fal', 'sign-out']"
          :style="{ transform: 'rotate(-90deg)' }"
      />
    </div>
  </div>
</template>

<script>
import foundation from "@/mixins/foundation";
import checkforupdates from "@/mixins/checkforupdates.js";
import TopNavigation from "@/components/TopNavigation.vue";
import BottomNavigation from "@/components/BottomNavigation.vue";
import MobileNavigation from "@/components/MobileNavigation.vue";
import ServiceSwitch from "@/components/ServiceSwitch.vue";
import MyCardInfos from "@/components/MyCardInfos.vue";
import {detect} from "detect-browser";
import moment from "moment";

export default {
  name: "App",
  components: {
    TopNavigation,
    BottomNavigation,
    MobileNavigation,
    ServiceSwitch,
    MyCardInfos,
  },
  mixins: [foundation, checkforupdates],
  data() {
    return {
      showIosInstallationHint: false,
    };
  },
  computed: {
    showServiceSwitches() {
      /* if (
         this.$route.name === "home" ||
         this.$route.name === "companies" ||
         this.$route.name === "buy-card"
       ) {
         return true;
       } else {
       if(this.$route.name == 'my-card') {
         return false;
       }*/
      return true
    },
    showCardInfos() {
      if (
          this.$route.name === "my-card" &&
          this.$store.state.cards.length >= 1
      ) {
        return true;
      }
      return false;
    },
    dsgvoID() {
      return this.$store.getCurrentCardinfos;
    },
  },
  methods: {
    openOffCanvas() {
      $(this.$refs.offCanvas).foundation("open");
    },
    promptA2HS(event, closeFn) {
      event.prompt();
      if (typeof closeFn === "function") {
        closeFn();
      }
      event.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          // console.log('User accepted the A2HS prompt.')
          // eslint-disable-next-line
          if (gtag) {
            // eslint-disable-next-line
            gtag("event", "App Installation");
          }
        } else {
          // console.log('User dismissed the A2HS prompt.')
          this.$eBus.$off("show-install-prompt");
        }
      });
    },
    performeUpdate() {
      window.location.reload();
    },
    updateContextFromStore() {
      this.$i18n.locale = this.$store.state.language;
    },
    hideIosInstallationHint() {
      this.showIosInstallationHint = false;
    },
    getCurrentSeason() {
      let currentYear = moment().year();
      let season = moment().isBetween(
          `${currentYear}-03-10`,
          `${currentYear}-10-31`
      )
          ? "sommer"
          : "winter";
      return season;
    },
  },
  beforeMount() {
    let season = this.getCurrentSeason();
    this.$store.dispatch("updateSeason", season);
    this.$store.dispatch("fetchBookmarks");
  },
  mounted() {
    const isIos = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test(userAgent);
    };
    // Detects if device is in standalone mode
    const isInStandaloneMode = () =>
        "standalone" in window.navigator && window.navigator.standalone;

    // Checks if should display install popup notification:
    if (isIos() && !isInStandaloneMode()) {
      this.showIosInstallationHint = true;
    }

    // listen for core update
    this.$eBus.$on("app-shell-update", () => {
      this.$notify({
        group: "shell",
        title: "Update",
        text: this.$t("pwa.updateAvailable"),
        duration: -1,
        ignoreDuplicates: true,
        position: "bottom center",
      });
    });

    // listen for events emited on the global event bus (workbox-window module)
    this.$eBus.$on("api-update", (event) => {
      console.log(event);
    });
    // listen for the install prompt event
    this.$eBus.$on("show-install-prompt", (event) => {
      this.$notify({
        group: "a2hs",
        title: this.$t("pwa.installHeadline"),
        text: this.$t("pwa.installText"),
        data: {
          prompt: event,
        },
        duration: -1,
        ignoreDuplicates: true,
      });
    });

    // listen for successfully installed event
    this.$eBus.$on("installed-web-app", (event) => {
      console.log(event);
    });

    // listen for the event to open the ios installation hint
    this.$eBus.$on("show-ios-installation-hint", () => {
      this.showIosInstallationHint = true;

      // try to close off-canvas menü
      try {
        $(this.$refs.offCanvas).foundation("close");
      } catch (e) {
        //console.log(e)
      }
    });

    //online/offline state
    window.addEventListener("online", () => {
      this.$eBus.$emit("connectionStateChanged");
    });
    window.addEventListener("offline", () => {
      this.$eBus.$emit("connectionStateChanged");
    });

    this.updateContextFromStore();
    this.$store.dispatch("updateBrowser", detect());
  },
};
</script>

<style lang="scss">
#offCanvas {
  &.is-open {
    z-index: 10000;

    // @include breakpoint(small only) {
    // 	background-color: rgba(0,0,0,.3);
    // }

    &.position-right {
      width: 100%;
      max-width: 400px;
    }
  }

  .btn-close-off-canvas {
    position: absolute;
    right: 40px;
    top: 27px;
    font-size: rem-calc(26);
    color: white;

    img {
      height: 26px;
      width: 26px;
    }
  }
  .off-canvas-inner-container {
    background-color: $dark-gray;
    color: white;
    height: 100%;
  }
}

.vue-notification-group {
  &:not(.a2hs-notification-group) {
    .vue-notification-wrapper {
      border-top-left-radius: 0.35rem;
      border-top-right-radius: 0.35rem;
    }
  }

  &.notification-registration-group {
    text-align: center;
  }
}

.top-nav-center {
  width: 100%;
}

.ios-installation-hint {
  @include xy-grid();
  position: fixed;
  bottom: 0;
  left: 1rem;
  right: 1rem;
  padding: 1rem;
  visibility: hidden;
  opacity: 0;
  transform: translate(0, 100%);
  transition: all 0.15s ease-in-out;
  background-color: get-color(primary);
  color: $white;
  border-top-right-radius: 0.5rem;
  border-top-left-radius: 0.5rem;
  /*box-shadow: 0px -1px 3px rgba($black, 0.15);*/
  z-index: 800;

  &.show-hint {
    z-index: 2000;
    opacity: 1;
    visibility: visible;
    transform: translate(0, 0);
  }

  .install-text {
    @include xy-cell(10, false, 0);
    padding-right: 0.5rem;
  }

  .btn-close-hint-container {
    @include xy-cell(2, false, 0);
    display: flex;
    justify-content: flex-end;

    .btn-close-hint {
      height: 100%;
      border-radius: 0.35rem;
      background-color: $dark-gray;
      color: $white;
    }
  }
  .install-icon {
    @include xy-cell(12);
    display: block;
    margin: 0 auto;
    margin-top: 1rem;
  }
}

</style>
